import { registerDeskPlugin } from '@ticket-manager-ap/components/ticket-show-desk/deskPluginRegistry';
import DlmLinkedOrders from './components/DlmLinkedOrders.vue';

export default function registerSoundStackTicketingVue(app) {
    registerDeskPlugin('rail', DlmLinkedOrders);
}
